import cns from "classnames";

import pages from "@Settings/pages";
import PageTemplate from "@Components/PageTemplate";
import stylesPageTemplate from "@Components/PageTemplate/index.module.scss";
import LayoutDefault from "@Layouts/default";

import Nav from "./Nav";
import styles from "./index.module.scss";

export type LayoutProps = React.PropsWithChildren;

const Layout: React.FC<LayoutProps> = ({ children }) => {
    return (
        <LayoutDefault>
            <PageTemplate
                breadcrumbs={[
                    {
                        text: pages.main.name,
                        link: pages.main.link,
                    },
                    {
                        text: pages.help.name,
                    },
                ]}
                className={styles.component}
            >
                <div
                    className={cns(
                        stylesPageTemplate.component__section,
                        styles.component__section,
                        styles.component__section_body
                    )}
                >
                    <h1
                        className={cns(
                            styles.component__title,
                            "text text_h3 text_uppercase"
                        )}
                    >
                        {pages.help.name}
                    </h1>

                    <Nav className={styles.component__nav} />

                    <div className={styles.component__content}>{children}</div>
                </div>
            </PageTemplate>
        </LayoutDefault>
    );
};

export default Layout;
